import { __decorate } from "tslib";
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MpfDocentsFrontendFeature = /*#__PURE__*/(() => {
  let MpfDocentsFrontendFeature = class MpfDocentsFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/docents/frontend","featureId":"mpf-docents"};
    }
    getFeatureFunctionality(functionality) {}
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfDocentsFrontendFeature_BaseFactory;
        return function MpfDocentsFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMpfDocentsFrontendFeature_BaseFactory || (ɵMpfDocentsFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfDocentsFrontendFeature)))(__ngFactoryType__ || MpfDocentsFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfDocentsFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'docents',
          loadChildren: () => import('./public/docents-frontend.module').then(m => m.DocentsFrontendModule)
        }])]
      });
    }
  };
  MpfDocentsFrontendFeature = __decorate([ClassName("MpfDocentsFrontendFeature")], MpfDocentsFrontendFeature);
  return MpfDocentsFrontendFeature;
})();
export { MpfDocentsFrontendFeature };